// src/encounter/services/use-encounter-vitals.ts
// GET /api/Patients/GetVitalsDetailsByEncounter?PatientId=&EncounterId= → PatientVital[].
// Ported from the PM app (use-encounter-vitals.ts). Bare array, no envelope; an
// encounter with no vitals yet returns [] (not 404). AbortSignal forwarded.
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { GetEncounterVitalsResponse, PatientVital } from '@/types/vitals-api';

export function useEncounterVitals(
  patientId: string | null | undefined,
  encounterId: string | null | undefined,
) {
  return useQuery<PatientVital[]>({
    queryKey: ['encounter-vitals', encounterId, patientId],
    enabled: !!patientId && !!encounterId,
    queryFn: ({ signal }) =>
      get<GetEncounterVitalsResponse>(
        `/api/Patients/GetVitalsDetailsByEncounter?PatientId=${encodeURIComponent(
          patientId as string,
        )}&EncounterId=${encodeURIComponent(encounterId as string)}`,
        { signal },
      ),
  });
}
